export default "__VITE_ASSET__D1IHmvP3__"